import Trans from 'next-translate/Trans';

// Libs
import { CHANGE_YOUR_PLAN } from '@/lib/settings/subscriptionInvoices/steps';
import { SINGLE_PLAN, TEAMS_PLAN } from '@/types/pricingTypes/planType';

// Components
import LinkBase from '@/components/base/LinkBase';

// Hooks
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';

// Routes
import { SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';

const DatepickerBannerDataRetention = () => {
    const { subscription } = useSubscription();

    if (
        (subscription?.product_key !== TEAMS_PLAN && subscription?.product_key !== SINGLE_PLAN) ||
        !subscription?.data_retention_date
    ) {
        return null;
    }

    return (
        <p
            className="max-w-[328px] rounded-md bg-icoGray-100 p-2.5 font-GMedium text-xs text-icoGray-500 dark:bg-icoDarkMode-anthracite dark:text-icoDarkMode-wolf"
            data-test-id="datepicker-data-retention-banner">
            <Trans
                i18nKey={
                    subscription?.product_key === TEAMS_PLAN
                        ? 'commons:datepicker_data_retention_warning_teams_plan'
                        : 'commons:datepicker_data_retention_warning_single_plan'
                }
                components={{
                    link: (
                        <LinkBase
                            href={{
                                pathname: SUBSCRIPTION_INVOICES,
                                query: {
                                    step: CHANGE_YOUR_PLAN
                                }
                            }}
                            className="text-icoBlue underline"
                        />
                    )
                }}
            />
        </p>
    );
};

export default DatepickerBannerDataRetention;
